import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

const Button = (props) => {
  var classes = ['btn']

  var typeClass;
  switch(props.type){
    case 'primary': typeClass = `btn-primary`; break;
    case 'success': typeClass = `btn-success`; break;
    case 'info': typeClass = `btn-info`; break;
    case 'warning': typeClass = `btn-warning`; break;
    case 'danger': typeClass = `btn-danger`; break;
    case 'notify': typeClass = `btn-notify`; break;
    default: typeClass = 'btn-default'
  }
  classes.push(typeClass)

  props.size ? classes.push(`btn-${props.size}`):classes.push(`btn-sm`)
  props.outline && classes.push("btn-outline")
  props.rounded && classes.push("btn-rounded")
  props.circle && classes.push("btn-circle")
  props.block && classes.push("btn-block")
  props.disabled && classes.push("disabled")

  classes.push(props.className)
  return <button className={classes.join(" ")} onClick={props.onClick}>{props.children}</button>
}

Button.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  size: PropTypes.oneOf(['xxs','xs','sm','','lg']),
  outline: PropTypes.bool,
  rounded: PropTypes.bool,
  circle: PropTypes.bool,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  className: "",
  style: {},
  type:'primary',
  size: 'sm',
  outline: false,
  rounded: false,
  circle: false,
  block: false,
  disabled: false,
}

const SaveButton = (props) => {
  //extend props. if disabled is true the button is always disabled
  props = {
    ...props,
    disabled: props.disabled ? props.disabled:props.saving,
    onClick: (props.saving || props.disabled) ? null:props.onClick
  }
  return (
    <Button {...props}>

      {(props.saving) ? (<i className="fa fa-pulse fa-spinner"/>):(props.children ? props.children:"Save")}

    </Button>
  )
}

SaveButton.propTypes = {
  saving: PropTypes.bool,
}

SaveButton.defaultProps = {
  saving: false
}

const ButtonGroup = (props) => {
  var sizeClass;
  var classes = [];
  switch(props.size){
    case 'xxs':
    case 'xs':
    case 'lg': sizeClass = `btn-group-${props.size}`; break;
    case 'md': sizeClass = ''; break;
    default: sizeClass = 'btn-group-sm'
  }
  classes.push(sizeClass)

  props.justify && classes.push("btn-group-justified")
  props.vertical && classes.push("btn-group-vertical")

  return(
    <div className={`btn-group ${props.className} ${classes.join(' ')}`}>
      {props.children}
    </div>
  )
}

ButtonGroup.propTypes = {
  className: PropTypes.string,
  justify: PropTypes.bool,
  vertical: PropTypes.bool,
  size: PropTypes.oneOf(['xxs','xs','sm','md','lg']),
}

class ButtonDropdown extends PureComponent{
  constructor(props){
    super(props)
    this.state = {
      isOpen: false
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.isOpen && !prevState.isOpen){
      document.addEventListener('click', this.handleDocumentClick)
    }
    if(!this.state.isOpen && prevState.isOpen){
      document.removeEventListener('click', this.handleDocumentClick)
    }
  }

  handleDocumentClick = (e) => {
    if (!this.dropdown.contains(e.target)) {
      this.setState({ isOpen: false });
    }
  }

  toggle = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  close = () => {
    this.setState({isOpen: false})
  }

  render() {
    const caretDirectionClass = `fa-caret-${this.props.caretDirection}`
    const isOpenClass = this.state.isOpen ? "open":""
    const isInputDropdown = this.props.isInputDropdown ? "input-group-btn":"btn-group"
    var dropdownClass = "dropdown-menu"

    if(this.props.direction === 'right'){
      dropdownClass += " pull-right"
    }

    return (
      <div className={`${isInputDropdown} ${isOpenClass}`} ref={(node) => this.dropdown = node}>
        <Button {...this.props} onClick={this.toggle}>
          {this.props.children}
          &nbsp;
          {this.state.isOpen ? <i className="fa fa-caret-down fa-fw"/>:<i className={`fa ${caretDirectionClass} fa-fw`}/>}
        </Button>
        <ul className={dropdownClass}>
          {React.Children.map(this.props.items, (child) =>{
            return React.cloneElement(child,{
              onClick: (e) => {
                this.close();
                child.props.onClick(e)
              }
            })
          })}
          {/*{this.props.items}*/}
        </ul>
      </div>
    )
  }
}

ButtonDropdown.propTypes = {
  ...Button.propTypes,
  items: PropTypes.array.isRequired,
  caretDirection: PropTypes.oneOf(['left', 'right']),
  direction: PropTypes.oneOf(['left', 'right']),
  isInputDropdown: PropTypes.bool,
}

ButtonDropdown.defaultProps = {
  ...Button.defaultProps,
  caretDirection: 'left',
  direction: 'left',
  isInputDropdown: false,
}

const ButtonDropdownItem = (props) => {
  return (
    <li><a href="#" onClick={props.onClick}>{props.name}</a></li>
  )
}

export {
  Button,
  ButtonDropdown,
  ButtonDropdownItem,
  ButtonGroup,
  SaveButton,
}
